export const URL_STS = process.env.REACT_APP_URL_STS;
export const URL_TRANSFORMER = process.env.REACT_APP_URL_TRANSFORMER;
